export function LoginActivity() {
  return (
    <section className="stack">
      <div className="panel">
        <h2>Login Activity</h2>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Staff Name</th>
                <th>Login Time</th>
                <th>Device / IP</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={4} style={{ textAlign: "center", padding: 24, color: "#94a3b8" }}>No login activity recorded yet.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
